const grid = document.getElementById("wishlist-grid");
const emptyState = document.getElementById("wishlist-empty");


function formatMoney(cents) {
  if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
    return Shopify.formatMoney(cents, Shopify.money_format);
  }
  return cents;
}

(function syncWishlistOnce() {
  try {
    const rawLocal = localStorage.getItem(WISHLIST_KEY);

    const local = rawLocal && rawLocal !== "null"
      ? JSON.parse(rawLocal)
      : [];

    const remote = Array.isArray(window.__CUSTOMER_WISHLIST__)
      ? window.__CUSTOMER_WISHLIST__
      : [];

    const merged = [...new Set([...local, ...remote])]
      .filter(id => id !== null && id !== "null")
      .map(id => Number(id))
      .filter(id => !isNaN(id));

    localStorage.setItem(WISHLIST_KEY, JSON.stringify(merged));

    document.dispatchEvent(new Event("wishlist:updated"));
  } catch (e) {
    console.warn("Wishlist corrupted during sync. Resetting.");
    localStorage.removeItem(WISHLIST_KEY);
  }
})();



function getWishlist() {
  const raw = localStorage.getItem(WISHLIST_KEY);

  if (!raw) return [];

  try {
    const parsed = JSON.parse(raw);

    if (!Array.isArray(parsed)) return [];

    return parsed
      .filter(id => id !== null && id !== "null")
      .map(id => Number(id))
      .filter(id => !isNaN(id));
  } catch (e) {
    console.warn("Wishlist corrupted. Resetting.");
    localStorage.removeItem(WISHLIST_KEY);
    return [];
  }
}

async function fetchProducts(ids) {
  const queries = ids.map(id => `id:${id}`).join(" OR ");
  const url = `/search/suggest.json?q=${encodeURIComponent(queries)}&resources[type]=product`;

  const res = await fetch(url);
  const data = await res.json();
  return data.resources.results.products || [];
}

function renderProducts(products) {
  grid.innerHTML = "";

  if (!products.length) {
    emptyState.style.display = "block";
    return;
  }

  products.forEach(product => {
    const card = document.createElement("div");
    card.className = "grid__item";

 card.innerHTML = `
  <div class="card card--standard">
    
    <!-- REMOVE BUTTON (SAFE OVERLAY) -->
    <button
      class="wishlist-remove"
      data-product-id="${product.id}"
      aria-label="Remove from wishlist"
    >
      ×
    </button>

    <a href="${product.url}" class="full-unstyled-link">
      <div class="card__media">
        <img src="${product.image}" alt="${product.title}">
      </div>
      <div class="card__content">
        <h3 class="card__heading h5">${product.title}</h3>
        <div class="price">  ${formatMoney(product.price)}</div>
      </div>
    </a>
  </div>
`;

    grid.appendChild(card);
  });
}

async function initWishlistPage() {
  const ids = getWishlist();

  if (!ids.length) {
    emptyState.style.display = "block";
    return;
  }

  const products = await fetchProducts(ids);
  renderProducts(products);
}

document.addEventListener("DOMContentLoaded", initWishlistPage);
document.addEventListener("wishlist:updated", initWishlistPage);


document.addEventListener("click", function (e) {
  const btn = e.target.closest(".wishlist-remove");
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  const productId = Number(btn.dataset.productId);

  let list = getWishlist().filter(id => id !== productId);
  localStorage.setItem("wishlist", JSON.stringify(list));

  document.dispatchEvent(new Event("wishlist:updated"));
}, true); // capture phase so links don’t hijack

function syncWishlistToCustomer() {
  if (!window.Shopify || !Shopify.customer) return;

  const wishlist = JSON.parse(localStorage.getItem("wishlist") || "[]");

  Shopify.analytics.publish("wishlist_sync", {
    wishlist
  });
}

